/**
 * 相簿的看大圖燈箱（PT-26；業主 2026-09-15 選「小型燈箱」）。
 *
 * 舊站 `Album/PhotoList.aspx` 用 lytebox（2026-09-15 實抓）：黑底 80%、白框、左右切換、「Image 1 of 4」、CLOSE。
 * 新站用原生 <dialog>：同頁放大、左右切換（按鈕與方向鍵）、Esc 或點黑底關閉、關閉後焦點回到那一張縮圖。
 *
 * ────────────────────────────────────────────────────────────────
 * 沒有 JavaScript 時
 * ────────────────────────────────────────────────────────────────
 * 縮圖本身就是連到 600 寬大圖的連結 —— 直接開圖。
 * ⚠️ Ctrl／⌘／Shift／中鍵點擊一律照瀏覽器原本的行為（開新分頁），不攔。
 */

const LINK_SELECTOR = 'a[data-p9-lightbox]';

function createButton(text: string, label: string, className: string): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = className;
  button.textContent = text;
  button.setAttribute('aria-label', label);
  return button;
}

function setup(links: HTMLAnchorElement[]): void {
  const dialog = document.createElement('dialog');
  dialog.className = 'p9-lightbox';
  dialog.setAttribute('aria-label', '看大圖');

  const figure = document.createElement('figure');
  figure.className = 'p9-lightbox-figure';

  const image = document.createElement('img');
  image.className = 'p9-lightbox-image';
  image.alt = '';

  const caption = document.createElement('figcaption');
  caption.className = 'p9-lightbox-caption';

  const counter = document.createElement('p');
  counter.className = 'p9-lightbox-counter';
  counter.setAttribute('aria-live', 'polite');

  const previous = createButton('‹', '上一張', 'p9-lightbox-nav');
  const next = createButton('›', '下一張', 'p9-lightbox-nav');
  const close = createButton('×', '關閉', 'p9-lightbox-close');

  figure.append(image, caption, counter);
  dialog.append(previous, figure, next, close);
  document.body.append(dialog);

  let current = 0;

  const show = (index: number): void => {
    current = (index + links.length) % links.length;

    const link = links[current];
    if (!link) {
      return;
    }

    const text = link.dataset['caption'] ?? '';

    image.src = link.href;
    image.alt = text;
    caption.textContent = text;
    caption.hidden = text.length === 0;
    counter.textContent = `第 ${current + 1} 張，共 ${links.length} 張`;
    previous.hidden = links.length < 2;
    next.hidden = links.length < 2;
  };

  links.forEach((link, index) => {
    link.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();
      show(index);
      dialog.showModal();
    });
  });

  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  close.addEventListener('click', () => dialog.close());

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      show(current - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + 1);
    }
  });

  // 點到黑底（dialog 本身，不是裡面的東西）就關
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    image.removeAttribute('src');
    links[current]?.focus();
  });
}

const links = [...document.querySelectorAll<HTMLAnchorElement>(LINK_SELECTOR)];

if (links.length > 0 && typeof HTMLDialogElement === 'function') {
  setup(links);
}
